import { FC, useMemo, memo } from 'react';
import { ProTooltip } from '../antd';
import classnames from 'classnames';
import { StepProps, StepsEnum } from './interface';

const Step: FC<StepProps> = memo(props => {
  const {
    className,
    style,
    children,
    description,
    status = 'wait',
    operationUserName,
    operationTime,
    examineInfo,
    text,
  } = props;
  const titleHtml = useMemo(() => {
    if (description) return description;
    if (!operationUserName && !operationTime) return '';
    return (
      <>
        {!!operationUserName && <div>{operationUserName}</div>}
        {!!operationTime && <div>{operationTime}</div>}
        {!!examineInfo && (
          <div className="text-line-feed">
            <span>审批意见:</span>
            <span className="p-l-s">{examineInfo}</span>
          </div>
        )}
      </>
    );
  }, [description, operationUserName, operationTime]);
  const classes = useMemo(() => {
    return classnames(className, 'yb-steps-step', {
      'yb-steps-step-wait': status === 'wait',
      'yb-steps-step-process': status === 'process',
      'yb-steps-step-finish': status === 'finish',
      'yb-steps-step-error': status === 'error',
    });
  }, [className, status]);
  return (
    <ProTooltip title={titleHtml} placement="bottomLeft">
      <div className={classes} style={style}>
        <div className="yb-steps-step-wrapper">
          <span className="yb-steps-step-text">{children || text}</span>
        </div>
      </div>
    </ProTooltip>
  );
});

Step.displayName = StepsEnum.Step;

export default Step;
